import React, { Component } from 'react'
import CleanersDashboardHeader from '../../CleanersDashboardComponents/Shared/DashboardCleanersHeader/DashboardCleanersHeader'
import * as DashboardError404Constant from './ErrorsConstant'
import ReusableButton from '../../SharedComponents/Button/Button'
import '../../CSS/dashboard.css'

class CleanersDashboardError404 extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div>
                <CleanersDashboardHeader />
                <ReusableButton className="ErrorButton" buttonText="View report" disabled={true}></ReusableButton>
                <div className="ErrorDashboard">
                    <p>{DashboardError404Constant.Error404DashboardParagraph}</p>
                    <p>{DashboardError404Constant.Error404DashboardParagraphPlease}</p>
                </div>
            </div>
        )
    }
}

export default CleanersDashboardError404;